import React, { useState } from 'react';
import { useStyles } from './ResetPassword.styles';
import { IconButton, InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';

import AppButton from '../../components/designe/app-button/AppButton';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Paths } from '../../shared/paths';
import { successToastMessage } from '../../components/layout/toast-root/toast';
import { useResetPasswordPage } from './useResetPasswordPage';
import AppFormTextField from '../../components/designe/app-form-text-field';
import theme from '../../styles/theme';

export default function ResetPassword() {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get('oobCode') || '';
  const navigate = useNavigate();
  // const mode = searchParams.get("mode");
  // const apiKey = searchParams.get("apiKey");
  // const lang = searchParams.get("lang");
  const { formik } = useResetPasswordPage(t, oobCode, () => {
    successToastMessage(t('resetPassword.successResetPasswordMessage'));
    navigate(Paths.signIn);
  });

  return (
    <div className={classes.resetPasswordWrapper}>
      <div className={classes.resetPasswordContentWrapper}>
        <form
          onSubmit={formik.handleSubmit}
          className={classes.resetPasswordForm}>
          <AppFormTextField
            label={t('resetPassword.password')}
            fullWidth
            name="password"
            type={showPassword ? 'text' : 'password'}
            className={classes.textField}
            formik={formik}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    size="large">
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <AppFormTextField
            label={t('resetPassword.confirmPassword')}
            fullWidth
            name="confirmPassword"
            type={showPassword ? 'text' : 'password'}
            className={classes.textField}
            formik={formik}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    size="large">
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <AppButton
            type="submit"
            fullWidth
            className={classes.resetPasswordSubmitButton}>
            {t('resetPassword.resetPassword')}
          </AppButton>
        </form>

        <div className={classes.backToLogin}>
          <Link className={classes.backToLoginButton} to={Paths.signIn}>
            {t('signIn.signIn')}
          </Link>
        </div>
      </div>
    </div>
  );
}
